import { AddressEnum, FormFieldTypes, AddressType } from '../../address/types/address-form-types.js';
import { ADD_NEW_DELIVERY_ADDRESS_LINK_POSITION, PHONE_FIELD_POSITION, phoneNumberField, taxIdInfoBox, TAX_ID_FIELD_POSITION, taxIDField, formCommonFields, addNewDeliveryAddressLink } from '../../address/constants.js';

const getDeliveryAddressFormFields = (flags, props) => {
    const isNewDeliveryAddressForm = !props?.defaultValues?.delivery?.id;
    const invoiceSameAsShippingAddressCheckboxField = {
        fieldName: AddressEnum.sameAsShipping,
        fieldType: FormFieldTypes.CHECKBOX,
    };
    const formFields = formCommonFields.concat([
        addNewDeliveryAddressLink,
        invoiceSameAsShippingAddressCheckboxField,
    ]);
    if (isNewDeliveryAddressForm) {
        formFields.splice(ADD_NEW_DELIVERY_ADDRESS_LINK_POSITION, 1);
    }
    formFields.splice(PHONE_FIELD_POSITION, 0, phoneNumberField);
    if (flags?.isTaxIdFlagEnabled) {
        formFields.push(taxIdInfoBox);
    }
    return formFields;
};
const getInvoiceAddressFormFields = (flags) => {
    const invoicePhoneField = { ...phoneNumberField, hasInfoMessage: false };
    const formFields = [...formCommonFields];
    formFields.splice(PHONE_FIELD_POSITION, 0, invoicePhoneField);
    if (flags?.isTaxIdFlagEnabled) {
        formFields.splice(TAX_ID_FIELD_POSITION, 0, taxIDField);
    }
    return formFields;
};
const getFlattenDefaultValues = (addressData) => {
    const result = {};
    const addressEntries = Object.entries(addressData || {});
    for (const [addressType, address] of addressEntries) {
        for (const [addressKey, addressValue] of Object.entries(address)) {
            result[`${addressType}_${addressKey}`] = addressValue;
        }
    }
    return result;
};
const convertFlatToNested = (flatObject) => {
    const defaultValues = {};
    for (const key in flatObject) {
        const [addressType, fieldName] = key.split('_');
        if (!defaultValues[addressType]) {
            defaultValues[addressType] = {};
            defaultValues[addressType]['type'] = addressType;
        }
        defaultValues[addressType][fieldName] = flatObject[key];
    }
    return defaultValues;
};
const prepareAddressFormPayload = (formData) => {
    const result = {};
    if (formData[AddressType.DELIVERY]) {
        const { delivery } = formData;
        result['invoiceSameAsDelivery'] = delivery?.sameAsShipping;
    }
    for (const [addressType, address] of Object.entries(formData || {})) {
        result[`${addressType}Address`] = {
            ...address,
        };
    }
    return result;
};
const normalizeAddress = (address, valid) => {
    return {
        ...address,
        additionalInformation: address.company || '',
        postalCode: address.postCode || '',
        countryShortName: address.region || '',
        valid: valid,
    };
};
const convertPUDOAddressToReadonlyAddress = (pudoInfo) => {
    if (!pudoInfo)
        return;
    const { collector, pudoPoint: { location } = {} } = pudoInfo;
    return {
        firstName: collector.firstName,
        lastName: collector.lastName,
        packstationName: location?.nameDisplay,
        street: location?.addressLine1 || '',
        additionalInformation: location?.addressLine2,
        postalCode: location?.postCode || '',
        city: location?.city || '',
        countryShortName: location?.countryCode || '',
        phoneNumber: collector.phoneNumber,
    };
};
const addAcceptedStatusToPayload = (selectedAddress, isAccepted, status) => {
    selectedAddress['additionalInfo'] = {
        ...selectedAddress['additionalInfo'],
        suggestionAccepted: isAccepted,
    };
    if (status) {
        selectedAddress['additionalInfo'] = {
            ...selectedAddress['additionalInfo'],
            suggestionStatus: status,
        };
    }
};
const shouldDisplayAddressValidatorComponent = (formDefaultValues, dirtyFields, type) => {
    const isSuggestionAcceptedNull = formDefaultValues[`${type}_uniservAddressValidationInfo`]?.suggestionAccepted === null;
    const isAddressFieldChanged = dirtyFields[`${type}_street`] ||
        dirtyFields[`${type}_postalCode`] ||
        dirtyFields[`${type}_city`] ||
        dirtyFields[`${type}_countryShortName`];
    return isSuggestionAcceptedNull || isAddressFieldChanged;
};

export { addAcceptedStatusToPayload, convertFlatToNested, convertPUDOAddressToReadonlyAddress, getDeliveryAddressFormFields, getFlattenDefaultValues, getInvoiceAddressFormFields, normalizeAddress, prepareAddressFormPayload, shouldDisplayAddressValidatorComponent };
//# sourceMappingURL=index.js.map
